export const FREQUENCY = {
    NONE: 'NONE',
    DAY: 'DAY',
    WEEK: 'WEEK',
    MONTH: 'MONTH',
};
